__turbopack_context__.v({
  "inner": "Blocks-module-scss-module__NDx43G__inner",
  "missing": "Blocks-module-scss-module__NDx43G__missing",
});
